import { fetchAuthSession } from "aws-amplify/auth";
import { API_SERVER } from "../config/constants";

export const sendMessageWithGroq = async (
  campaignId,
  postId,
  payload,
  organizationskuuid
) => {
  try {
    const session = await fetchAuthSession();
    const request = await fetch(
      `${API_SERVER}/groq/organization/${organizationskuuid}/campaigns/${campaignId}/posts/${postId}/assistant/messages`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${session.tokens.idToken.toString()}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await request.json();
    return data.messages;
  } catch (error) {
    console.error("Error interacting with the groq assistant: ", error);
    throw error;
  }
};
